import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

const switchBaseStyles = ({ theme, isActive }) => css`
  background-color: ${isActive ? theme.colors.r500 : theme.colors.b100};
  border: 1px solid ${theme.colors.b100};
  cursor: pointer;
  position: relative;
  width: 48px;
  height: 24px;
  transition: 0.4s;
  border-radius: 22px;
`;

const Switch = styled('div')(switchBaseStyles);

const sliderBaseStyles = ({ theme }) => css`
  border: 1px solid ${theme.colors.n700};
  // box-shadow: 0 0 3px 1px ${theme.colors.n700};
  position: absolute;
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  background-color: ${theme.colors.white};
  transition: 0.4s;
  border-radius: 22px;
`;

const sliderActiveStyles = ({ isActive }) =>
  isActive &&
  css`
    transform: translateX(24px);
  `;

const Slider = styled('span')(sliderBaseStyles, sliderActiveStyles);

const ToggleSwitch = ({ isActive }) => (
  <Switch isActive={isActive}>
    <Slider isActive={isActive} />
  </Switch>
);

ToggleSwitch.propTypes = {
  isActive: PropTypes.bool,
};

export default ToggleSwitch;
